import { render } from "./TheUserCoupon.vue?vue&type=template&id=3831b9b1"
import script from "./TheUserCoupon.vue?vue&type=script&lang=js"
export * from "./TheUserCoupon.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__